import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import ArnicaMappingForm from './ArnicaMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function ArnicaCredentialsForm(props, ref) {
    const fields = [
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator],
        }, {
            name: "authToken",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }];

        return (
            <GenericPullCredentialsForm
                {...props}
                ref={ref}
                fields={fields}
                MappingForm={ArnicaMappingForm}
                initialValue={{ apiEndpoint: "https://api.app.arnica.io" }}
            />
        )
}

export default forwardRef(ArnicaCredentialsForm);